import React from 'react'

const GoBackButton = ({onClick}) => {
  if (onClick !== undefined) {
    return(
      <button className="btn btn-line btn-lg" onClick={ onClick } >
        Go back
      </button>
    )
  } else {
    return(null)
  }
}

export default GoBackButton
